(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8648],{

/***/ 33730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 74152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 77085:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reward",
      function () {
        return __webpack_require__(19990);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTooltip_useTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/uikit/src/theme/light.ts
var light = __webpack_require__(93723);
// EXTERNAL MODULE: ./packages/uikit/src/theme/dark.ts
var dark = __webpack_require__(4409);
// EXTERNAL MODULE: ./packages/uikit/src/util/getPortalRoot.ts
var getPortalRoot = __webpack_require__(77382);
;// CONCATENATED MODULE: ./packages/uikit/src/util/isTouchDevice.ts
var isTouchDevice = function isTouchDevice() {
    return  true && ("ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
    navigator.msMaxTouchPoints > 0);
};
/* harmony default export */ var util_isTouchDevice = (isTouchDevice);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/StyledTooltip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  &,\n  &::before {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    z-index: -1;\n  }\n\n  &::before {\n    content: "";\n    transform: rotate(45deg);\n    background: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  font-size: 14px;\n  line-height: 150%;\n  border-radius: 16px;\n  max-width: 320px;\n  z-index: 101;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ';\n  white-space: pre-line;\n  &[data-popper-placement^="top"] > ',
        ' {\n    bottom: -4px;\n  }\n\n  &[data-popper-placement^="bottom"] > ',
        ' {\n    top: -4px;\n  }\n\n  &[data-popper-placement^="left"] > ',
        ' {\n    right: -4px;\n  }\n\n  &[data-popper-placement^="right"] > ',
        " {\n    left: -4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfe0fd96-0"
}).withConfig({
    componentId: "sc-345c868b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var StyledTooltip = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-cfe0fd96-1"
}).withConfig({
    componentId: "sc-345c868b-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, Arrow, Arrow, Arrow, Arrow);

;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx













var animationVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
var animationMap = {
    initial: "initial",
    animate: "animate",
    exit: "exit"
};
var invertTheme = function invertTheme(currentTheme) {
    if (currentTheme.isDark) {
        return light/* default */.Z;
    }
    return dark/* default */.Z;
};
var useTooltip = function useTooltip(content, options) {
    var _placement = options.placement, placement = _placement === void 0 ? "auto" : _placement, _trigger = options.trigger, trigger = _trigger === void 0 ? "hover" : _trigger, _arrowPadding = options.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 16 : _arrowPadding, _tooltipPadding = options.tooltipPadding, tooltipPadding = _tooltipPadding === void 0 ? {
        left: 16,
        right: 16
    } : _tooltipPadding, _tooltipOffset = options.tooltipOffset, tooltipOffset = _tooltipOffset === void 0 ? [
        0,
        10
    ] : _tooltipOffset, _hideTimeout = options.hideTimeout, hideTimeout = _hideTimeout === void 0 ? 100 : _hideTimeout;
    var ref = (0,react.useState)(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = (0,react.useState)(null), tooltipElement = ref1[0], setTooltipElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var isHoveringOverTooltip = (0,react.useRef)(false);
    var hideTimeoutRef = (0,react.useRef)();
    var hideTooltip = (0,react.useCallback)(function(e) {
        var hide = function hide() {
            e.stopPropagation();
            e.preventDefault();
            setVisible(false);
        };
        if (trigger === "hover") {
            if (hideTimeoutRef.current) {
                window.clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = false;
            }
            if (!isHoveringOverTooltip.current) {
                hideTimeoutRef.current = window.setTimeout(function() {
                    if (!isHoveringOverTooltip.current) {
                        hide();
                    }
                }, hideTimeout);
            }
        } else {
            hide();
        }
    }, [
        tooltipElement,
        trigger,
        hideTimeout
    ]);
    var showTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        setVisible(true);
        if (trigger === "hover") {
            if (e.target === targetElement) {
                // If we were about to close the tooltip and got back to it
                // then prevent closing it.
                clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = true;
            }
        }
    }, [
        tooltipElement,
        targetElement,
        trigger
    ]);
    var toggleTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setVisible(!visible);
    }, [
        visible
    ]);
    // Trigger = hover
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "hover") return undefined;
        if (util_isTouchDevice()) {
            targetElement.addEventListener("touchstart", showTooltip);
            targetElement.addEventListener("touchend", hideTooltip);
        } else {
            targetElement.addEventListener("mouseenter", showTooltip);
            targetElement.addEventListener("mouseleave", hideTooltip);
        }
        return function() {
            targetElement.removeEventListener("touchstart", showTooltip);
            targetElement.removeEventListener("touchend", hideTooltip);
            targetElement.removeEventListener("mouseenter", showTooltip);
            targetElement.removeEventListener("mouseleave", showTooltip);
        };
    }, [
        trigger,
        targetElement,
        hideTooltip,
        showTooltip
    ]);
    // Keep tooltip open when cursor moves from the targetElement to the tooltip
    (0,react.useEffect)(function() {
        if (tooltipElement === null || trigger !== "hover") return undefined;
        tooltipElement.addEventListener("mouseenter", showTooltip);
        tooltipElement.addEventListener("mouseleave", hideTooltip);
        return function() {
            tooltipElement.removeEventListener("mouseenter", showTooltip);
            tooltipElement.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        trigger,
        tooltipElement,
        hideTooltip,
        showTooltip
    ]);
    // Trigger = click
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "click") return undefined;
        targetElement.addEventListener("click", toggleTooltip);
        return function() {
            return targetElement.removeEventListener("click", toggleTooltip);
        };
    }, [
        trigger,
        targetElement,
        visible,
        toggleTooltip
    ]);
    // Handle click outside
    (0,react.useEffect)(function() {
        if (trigger !== "click") return undefined;
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_instanceof/* default */.Z)(target, Node)) {
                if (tooltipElement != null && targetElement != null && !tooltipElement.contains(target) && !targetElement.contains(target)) {
                    setVisible(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        trigger,
        targetElement,
        tooltipElement
    ]);
    // Trigger = focus
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "focus") return undefined;
        targetElement.addEventListener("focus", showTooltip);
        targetElement.addEventListener("blur", hideTooltip);
        return function() {
            targetElement.removeEventListener("focus", showTooltip);
            targetElement.removeEventListener("blur", hideTooltip);
        };
    }, [
        trigger,
        targetElement,
        showTooltip,
        hideTooltip
    ]);
    // On small screens Popper.js tries to squeeze the tooltip to available space without overflowing beyond the edge
    // of the screen. While it works fine when the element is in the middle of the screen it does not handle well the
    // cases when the target element is very close to the edge of the screen - no margin is applied between the tooltip
    // and the screen edge.
    // preventOverflow mitigates this behaviour, default 16px paddings on left and right solve the problem for all screen sizes
    // that we support.
    // Note that in the farm page where there are tooltips very close to the edge of the screen this padding works perfectly
    // even on the iPhone 5 screen (320px wide), BUT in the storybook with the contrived example ScreenEdges example
    // iPhone 5 behaves differently overflowing beyond the edge. All paddings are identical so I have no idea why it is,
    // and fixing that seems like a very bad use of time.
    var ref4 = (0,usePopper/* usePopper */.D)(targetElement, tooltipElement, {
        placement: placement,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: arrowPadding
                }
            },
            {
                name: "offset",
                options: {
                    offset: tooltipOffset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: tooltipPadding
                }
            }, 
        ]
    }), styles = ref4.styles, attributes = ref4.attributes;
    var tooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationMap), {
        variants: animationVariants,
        transition: {
            duration: 0.3
        },
        ref: setTooltipElement,
        style: styles.popper
    }), attributes.popper), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: invertTheme,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                ref: setArrowElement,
                style: styles.arrow
            })
        ]
    }));
    var AnimatedTooltip = /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: visible && tooltip
        })
    });
    var portal = (0,getPortalRoot/* default */.Z)();
    var tooltipInPortal = portal ? /*#__PURE__*/ (0,react_dom.createPortal)(AnimatedTooltip, portal) : null;
    return {
        targetRef: setTargetElement,
        tooltip: tooltipInPortal !== null && tooltipInPortal !== void 0 ? tooltipInPortal : AnimatedTooltip,
        tooltipVisible: visible
    };
};
/* harmony default export */ var useTooltip_useTooltip = (useTooltip);


/***/ }),

/***/ 77214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65208);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93293);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: ",
        ";\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    /* font-size: 20px; */\n    color: #999;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-62693d3a-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : "16px";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .escapeRegExp */ .hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,_noahswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        // const now = new Date();
        // const hours = now.getHours().toString().padStart(2, '0');
        // const minutes = now.getMinutes().toString().padStart(2, '0');
        // const seconds = now.getSeconds().toString().padStart(2, '0');
        // const formattedTime = `${hours}:${minutes}:${seconds}`;
        // console.log(formattedTime + '---输入的值', event.target.value)
        },
        // universal input options
        inputMode: "decimal",
        title: t("noah98"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 45061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74116);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44850);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62276);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* eslint-disable */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c32a5c15-0"
})(_templateObject());
var IconImg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c32a5c15-1"
})(_templateObject1());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size",
        "type"
    ]);
    var ref = (0,_noahswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: type === "info" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconImg, {
                    src: "/images/all/info.png",
                    alt: ""
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "textSubtle",
                    width: size
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionHelper);


/***/ }),

/***/ 19990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ reward; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
// EXTERNAL MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx + 1 modules
var CurrencyLogo = __webpack_require__(60764);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(92510);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(55999);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx
var NumericalInput = __webpack_require__(77214);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Reward/components/Tabs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* width: 120px; */\n  background-color: transparent;\n  height: 40px;\n  font-size: 14px;\n  &:nth-child(1) {\n    border-radius: 6px 0 0 6px;\n  }\n  &:nth-child(2) {\n    border-radius: 0 6px 6px 0;\n    border-left: 0;\n    margin-left: -2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var TabsWrap = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-87a9dbc-0"
})(_templateObject());
var TabsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-87a9dbc-1"
})(_templateObject1());
var Tabs = function(param) {
    var _tabList = param.tabList, tabList = _tabList === void 0 ? [] : _tabList, _type = param.type, type = _type === void 0 ? 0 : _type, setType = param.setType;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleCheck = function(item) {
        setType(item.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsWrap, {
        children: // #FFE169
        tabList.map(function(v, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsButton, {
                style: {
                    background: type === i ? "#FFE169" : "transparent"
                },
                isMobile: isMobile,
                onClick: function() {
                    handleCheck(v);
                },
                children: [
                    " ",
                    v.label
                ]
            }, i);
        })
    });
};
/* harmony default export */ var components_Tabs = (Tabs);

;// CONCATENATED MODULE: ./src/views/Reward/components/LockModal.tsx

function LockModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    LockModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LockModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* align-items: center; */\n  background: transparent;\n  display: flex;\n  padding: 0 30px 30px;\n  /* justify-content: center; */\n  flex-direction: column;\n"
    ]);
    LockModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 320px;\n  max-width: 420px !important;\n  padding-bottom: 100px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 10px 1rem 10px 0;\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11ab35bd-0"
})(LockModal_templateObject());
var ModalBody = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-11ab35bd-1"
})(LockModal_templateObject1());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11ab35bd-2"
})(_templateObject2());
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11ab35bd-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var width = param.width;
    return width || "100%";
});
var LockModal = function(param) {
    var onDismiss = param.onDismiss, _allData = param.allData, allData = _allData === void 0 ? {} : _allData, handleSubmit = param.handleSubmit;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,react.useState)(0), type = ref[0], setType = ref[1];
    var ref1 = (0,react.useState)(), numInput = ref1[0], setNumInput = ref1[1];
    var debounceNumInput = (0,useDebounce/* default */.Z)(numInput, 200);
    var tabList = [
        // 增加质押
        {
            id: 1,
            label: t("noah326"),
            value: 0
        },
        // 减少质押
        {
            id: 2,
            label: t("noah327"),
            value: 1
        }, 
    ];
    var onUserInput = (0,react.useCallback)(function(value) {
        onUserInput(value);
    }, []);
    var buttonText = function() {
        if (!type && Number(debounceNumInput) > Number(allData.balanceEsNoah)) {
            return t("Insufficient %coin% balance", {
                coin: "esNOAH"
            });
        }
        if (type && Number(debounceNumInput) > Number(allData.lockEsNoah)) {
            return t("Insufficient %coin% balance", {
                coin: "esNOAH"
            });
        }
        // 确定
        if (Number(debounceNumInput) > 0) {
            return t("noah78");
        }
        return t("noah303");
    };
    var handleSubmit1 = function() {
        handleSubmit(type, debounceNumInput);
    };
    (0,react.useEffect)(function() {
        setNumInput("");
    }, [
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalContainer */.F0, {
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: !isMobile ? "300px" : "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            style: {
                width: isMobile ? "100% " : "418px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                            style: {
                                fontSize: "20px",
                                fontWeight: "500"
                            },
                            children: t("noah321")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            onClick: onDismiss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                width: "24px",
                                color: "#000"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tabs, {
                            type: type,
                            setType: setType,
                            tabList: tabList
                        }),
                        !type && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    mb: "10px",
                                    mt: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "14px",
                                            children: t("noah328")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            fontSize: "14px",
                                            children: [
                                                (0,formatBalance/* getRes */.sR)(allData === null || allData === void 0 ? void 0 : allData.lockedData, 4) || "0.0000",
                                                " esNOAH"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "#14162A",
                                                mr: "10px",
                                                small: true,
                                                children: t("noah314")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            small: true,
                                            children: [
                                                (0,formatBalance/* getRes */.sR)(allData.lockTimeEsNoah, 1) || "0.0",
                                                "\xa0",
                                                t("noah275")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            background: " #FAFAFA;",
                            borderRadius: "6px",
                            p: "15px",
                            mt: "15px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "14px",
                                            children: !type ? t("noah329") : t("noah336")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            fontSize: "14px",
                                            color: "#85868A",
                                            onClick: function() {
                                                if (!type) {
                                                    setNumInput(allData.balanceEsNoah);
                                                } else {
                                                    setNumInput(allData.lockEsNoah);
                                                }
                                            },
                                            children: [
                                                !type ? t("noah330") : t("noah337"),
                                                ":",
                                                " ",
                                                !type ? (0,formatBalance/* getRes */.sR)(allData.balanceEsNoah || "0.0000", 4) || "0.0000" : (0,formatBalance/* getRes */.sR)(allData.lockEsNoah, 4) || "0.0000"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericalInput/* default */.Z, {
                                                align: "left",
                                                fontSize: "20px",
                                                placeholder: t("0.0"),
                                                value: numInput,
                                                onUserInput: function(val) {
                                                    var val1 = val;
                                                    // if (!type && val1 > Number(allData.balanceEsNoah)) {
                                                    //   val1 = Number(allData.balanceEsNoah)
                                                    // }
                                                    // if (type && val1 > Number(allData.lockEsNoah)) {
                                                    //   val1 = Number(allData.lockEsNoah)
                                                    // }
                                                    setNumInput(val1);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                            width: "25%",
                                            style: {
                                                flexDirection: "row-reverse",
                                                paddingRight: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "#000",
                                                fontSize: "14px",
                                                children: "esNOAH"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            my: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: t("noah313")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "10px",
                                            fontSize: "14px",
                                            children: (0,formatBalance/* getRes */.sR)((allData === null || allData === void 0 ? void 0 : allData.lockEsNoah) || "0.0000", 4) || "0.0000"
                                        }),
                                        Number(numInput) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/small-img/to.png",
                                                    style: {
                                                        width: "14px",
                                                        height: "10px"
                                                    },
                                                    alt: "",
                                                    className: "icon-cls"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontSize: "14px",
                                                    ml: "10px",
                                                    children: !type ? Number(allData.lockEsNoah) + Number(numInput) : Number(allData.lockEsNoah) - Number(numInput)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            width: "100%",
                            mb: "20px",
                            disabled: !Number(debounceNumInput) || !type && Number(debounceNumInput) > Number(allData.balanceEsNoah) || type && Number(debounceNumInput) > Number(allData.lockEsNoah),
                            onClick: function() {
                                handleSubmit1();
                            },
                            children: buttonText()
                        }),
                        !type ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                maxHeight: "150px",
                                overflowY: "scroll",
                                margin: "0 -4px",
                                padding: "0 4px 20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: [
                                        "\xb7 ",
                                        t("noah332")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    pl: "12px",
                                    color: "#85868A",
                                    mb: "10px",
                                    children: t("noah333")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: [
                                        "\xb7 ",
                                        t("noah334")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    pl: "12px",
                                    color: "#85868A",
                                    mb: "10px",
                                    children: t("noah335")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: [
                                        "\xb7 ",
                                        t("noah448")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    pl: "12px",
                                    color: "#85868A",
                                    mb: "30px",
                                    children: t("noah449")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: [
                                        "\xb7 ",
                                        t("noah440")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    pl: "12px",
                                    color: "#85868A",
                                    mb: "10px",
                                    children: t("noah441")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_LockModal = (LockModal);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(61905);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/components/ResultModal/index.tsx
var ResultModal = __webpack_require__(28393);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(42808);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(72234);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(2688);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/config/abi/Bribe.json
var Bribe = __webpack_require__(33109);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 25 modules
var wagmi_esm = __webpack_require__(38109);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var contracts_lib_esm = __webpack_require__(64146);
;// CONCATENATED MODULE: ./src/views/Reward/index.tsx
/* eslint-disable */ 






function Reward_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  margin-bottom: 100px;\n  position: relative;\n  z-index: 10000;\n  .flex-received {\n    background: #fafafa;\n    border-radius: 4px;\n    padding: 15px;\n    margin-top: 30px;\n    display: flex;\n    justify-content: space-between;\n  }\n  /* mobile */\n  .box-cls {\n  }\n"
    ]);
    Reward_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Reward_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-bottom: 33px;\n  // background-color: #fff;\n  // padding: 40px 0;\n  // border-radius: 30px;\n"
    ]);
    Reward_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Reward_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  /* padding-top: 40px; */\n"
    ]);
    Reward_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Reward_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(50% - 10px);\n  // padding: 0 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 40px;\n  border-radius: 30px;\n  &:nth-child(1) {\n    margin-right: 20px;\n  }\n"
    ]);
    Reward_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48%;\n  font-size: 14px;\n  border-color: #dbdbdb;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fafafa;\n  border-radius: 10px;\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  color: #14162a;\n  margin: 12px 0 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* padding: 30px 0; */\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  .headText {\n    color: #85868a;\n    flex: 1;\n    font-size: 12px;\n    &:nth-child(1) {\n      flex: 0.5;\n    }\n    &:nth-child(2) {\n      flex: 1;\n      text-align: right;\n    }\n    &:nth-child(3) {\n      text-align: right;\n    }\n    &:nth-child(4) {\n      text-align: right;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .bodyText {\n    flex: 1;\n    margin-bottom: 20px;\n    &:nth-child(1) {\n      flex: 0.5;\n    }\n    &:nth-child(2) {\n      flex: 1;\n      text-align: right;\n      flex-direction: row-reverse;\n    }\n    &:nth-child(3) {\n      text-align: right;\n    }\n    &:nth-child(4) {\n      text-align: right;\n      flex-direction: row-reverse;\n    }\n  }\n  .nodata {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    min-height: 300px;\n  }\n  .button-cls {\n    background-color: transparent;\n    padding: 0 100px;\n    border-color: #c1c2c4;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





























var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-0"
})(Reward_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "100%" : "1100px";
});
var TopCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-1"
})(Reward_templateObject1());
var BoxWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-2"
})(Reward_templateObject2());
var HalfWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-3"
})(Reward_templateObject3());
var HalfButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-533f7fd4-4"
})(_templateObject4());
var ReceiveCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-5"
})(_templateObject5());
var TableWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-6"
})(_templateObject6());
var TableHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-7"
})(_templateObject7());
var TableCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-533f7fd4-8"
})(_templateObject8());
function Reward() {
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var isXxxxl = (0,useMatchBreakpoints/* default */.Z)().isXxxxl;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isWrongNetwork = (0,useActiveChainId/* useActiveChainId */.gi)().isWrongNetwork;
    var onPresentConnectModal = (0,useWallet/* useWallet */.O)().onPresentConnectModal;
    var isMobile = !isXxxxl;
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId
    var ref = (0,react.useState)({
        lockedData: 0,
        retrieveStatus: 0,
        lockEsNoah: 0,
        balanceEsNoah: 0,
        lockTimeEsNoah: 0,
        collectedEsNoah: 0,
        lockedNoah: 0
    }), allData = ref[0], setAllData = ref[1];
    var ref1 = (0,react.useState)({
        price: 0,
        weekReward: 0
    }), serverData = ref1[0], setServerData = ref1[1];
    var ref2 = (0,react.useState)(0), estiValue = ref2[0], setEstiValue = ref2[1];
    var timerRef = (0,react.useRef)();
    var timerRef1 = (0,react.useRef)();
    var ref3 = (0,react.useState)(false), reset = ref3[0], setReset = ref3[1];
    var votingEscrowContract = (0,useContract/* useVotingEscrowContract */.$t)();
    var esnoahContract = (0,useContract/* useEsnoahContract */.O4)();
    var rewardsDistributorContract = (0,useContract/* useRewardsDistributorContract */.sB)();
    var vesterContract = (0,useContract/* useVesterContract */.v7)();
    var voterContract = (0,useContract/* useVoterContract */.m4)();
    var MinterContract = (0,useContract/* useMinterContract */.jS)();
    var ref4 = (0,wagmi_esm/* useSigner */.mx)(), signer = ref4.data;
    // console.log('votingEscrowContract', votingEscrowContract);
    var ref5 = (0,react.useState)({
        attemptingTxn: false,
        rewardErrorMessage: undefined,
        txHash: undefined
    }), ref6 = ref5[0], attemptingTxn = ref6.attemptingTxn, rewardErrorMessage = ref6.rewardErrorMessage, txHash = ref6.txHash, setRewardState = ref5[1];
    var ref7 = (0,react.useState)(""), pendingText = ref7[0], setPendingText = ref7[1];
    var ref8 = (0,react.useState)([]), tableData = ref8[0], setTableData = ref8[1];
    // 领取成功/领取失败
    var ref9 = (0,react.useState)({
        successText: t("noah244"),
        failText: t("noah245")
    }), ref10 = ref9[0], successText = ref10.successText, failText = ref10.failText, setText = ref9[1];
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ResultModal/* default */.ZP, {
        pendingText: pendingText,
        hash: txHash,
        attemptingTxn: attemptingTxn,
        errorMessage: rewardErrorMessage,
        successText: successText,
        failText: failText,
        isSuccess: function() {
            console.log("successRewardGetdata");
        // setTimeout(() => {
        //   getData()
        // }, 1000)
        }
    }), false, true, "ResultModal"), 1), onPresentResultModal = ref11[0];
    // 获取详细数据
    var getData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lockedData, endTimes, esnoahBalance, claimable, lockEsNoah, claimableAmount, vesting, claimabled, userVotes, allZeros, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            11,
                            ,
                            12
                        ]);
                        if (!account) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            votingEscrowContract.locked(account)
                        ];
                    case 1:
                        lockedData = _state.sent();
                        return [
                            4,
                            votingEscrowContract.locked_end(account)
                        ];
                    case 2:
                        endTimes = _state.sent();
                        return [
                            4,
                            esnoahContract.balanceOf(account)
                        ];
                    case 3:
                        esnoahBalance = _state.sent();
                        return [
                            4,
                            rewardsDistributorContract.claimable(account)
                        ];
                    case 4:
                        claimable = _state.sent();
                        return [
                            4,
                            vesterContract.balances(account)
                        ];
                    case 5:
                        lockEsNoah = _state.sent();
                        return [
                            4,
                            vesterContract.getNextClaimableAmount(account)
                        ];
                    case 6:
                        claimableAmount = _state.sent();
                        return [
                            4,
                            votingEscrowContract.vestingTime(account, 0)
                        ];
                    case 7:
                        vesting = _state.sent();
                        return [
                            4,
                            vesterContract.claimable(account)
                        ];
                    case 8:
                        claimabled = _state.sent() || 0;
                        return [
                            4,
                            voterContract["userVotes(address)"](account) // 批量查询用户投票数据
                        ];
                    case 9:
                        userVotes = _state.sent();
                        allZeros = true;
                        if (userVotes._votes.length === 0) {
                            allZeros = false;
                        } else {
                            allZeros = userVotes._votes.every(function(item) {
                                return Number((0,formatBalance/* formatBigNumberToFixed */.U1)(item)) === 0;
                            });
                        }
                        if (allZeros) {
                            // console.log("每一项都为 0");
                            setReset(true);
                        } else {
                            // console.log("某一项不为 0");
                            setReset(false);
                        }
                        if (Number(endTimes === null || endTimes === void 0 ? void 0 : endTimes.toString()) === 0) {
                            setAllData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, allData), {
                                lockedData: (0,formatBalance/* formatBigNumberToFixed */.U1)(lockedData.amount || 0).toString(),
                                lockEsNoah: (Number((0,formatBalance/* formatBigNumberToFixed */.U1)(lockEsNoah || 0).toString()) - Number((0,formatBalance/* formatBigNumberToFixed */.U1)(claimableAmount || 0).toString())).toString(),
                                balanceEsNoah: (0,formatBalance/* formatFixedNumber */.w$)(esnoahBalance || 0, 15).toString(),
                                collectedEsNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimable || 0).toString(),
                                lockedNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimabled || 0).toString(),
                                retrieveStatus: 0
                            }));
                        } else if (Number(endTimes === null || endTimes === void 0 ? void 0 : endTimes.toString()) < new Date().getTime() / 1000) {
                            setAllData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, allData), {
                                lockedData: (0,formatBalance/* formatBigNumberToFixed */.U1)(lockedData.amount || 0).toString(),
                                lockEsNoah: (Number((0,formatBalance/* formatBigNumberToFixed */.U1)(lockEsNoah || 0).toString()) - Number((0,formatBalance/* formatBigNumberToFixed */.U1)(claimableAmount || 0).toString())).toString(),
                                balanceEsNoah: (0,formatBalance/* formatFixedNumber */.w$)(esnoahBalance || 0, 15).toString(),
                                collectedEsNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimable || 0).toString(),
                                lockedNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimabled || 0).toString(),
                                retrieveStatus: 1
                            }));
                        } else {
                            setAllData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, allData), {
                                lockedData: (0,formatBalance/* formatBigNumberToFixed */.U1)(lockedData.amount || 0).toString(),
                                lockEsNoah: (Number((0,formatBalance/* formatBigNumberToFixed */.U1)(lockEsNoah || 0).toString()) - Number((0,formatBalance/* formatBigNumberToFixed */.U1)(claimableAmount || 0).toString())).toString(),
                                balanceEsNoah: (0,formatBalance/* formatFixedNumber */.w$)(esnoahBalance || 0, 15).toString(),
                                collectedEsNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimable || 0).toString(),
                                lockedNoah: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimabled || 0).toString(),
                                lockTimeEsNoah: (vesting.toString() / 604800).toFixed(1),
                                retrieveStatus: 2
                            }));
                        }
                        _state.label = 10;
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        error = _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!account) {
            setAllData({
                lockedData: 0,
                retrieveStatus: 0,
                lockEsNoah: 0,
                balanceEsNoah: 0,
                lockTimeEsNoah: 0,
                collectedEsNoah: 0,
                lockedNoah: 0
            });
        }
        if (!account && !votingEscrowContract && !esnoahContract && !rewardsDistributorContract && !vesterContract && !voterContract) return;
        getData();
        timerRef.current = setInterval(function() {
            getData();
        }, 6000);
        // eslint-disable-next-line consistent-return
        return function() {
            clearInterval(timerRef.current);
        };
    }, [
        account,
        votingEscrowContract,
        esnoahContract,
        rewardsDistributorContract,
        vesterContract,
        voterContract
    ]);
    // 接口获取投票奖励数据
    var fetch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, baseURL, chainid, ref1, data, code, datas, contractParams, ref2, tokens, claimables, dataFormat, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
                        return [
                            4,
                            (0,service/* getRewards */.rl)({
                                baseURL: baseURL,
                                chainid: chainid,
                                account: account
                            })
                        ];
                    case 1:
                        ref1 = _state.sent(), data = ref1.data, code = ref1.code;
                        if (!(code === 0)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        datas = (data === null || data === void 0 ? void 0 : data.map(function(v) {
                            return v[Object.keys(v)[0]];
                        })) || [];
                        contractParams = datas.map(function(v) {
                            return v === null || v === void 0 ? void 0 : v.bribe;
                        }) || [];
                        return [
                            4,
                            voterContract.earnedBribes(contractParams, account)
                        ];
                    case 3:
                        ref2 = _state.sent(), tokens = ref2.tokens, claimables = ref2.claimables;
                        dataFormat = datas.map(function(item, i) {
                            var ref;
                            // console.log(JSBI.BigInt(new BigNumber(item.bribeList[0].usdPrice)), '123144')
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                tokenListValue: claimables[i].reduce(function(total, currentValue, currentIndex) {
                                    if (currentIndex > 0) {
                                        return total + Number((0,formatBalance/* formatBigNumberToFixed */.U1)(currentValue || 0).toString());
                                    }
                                    return 0;
                                }, 0),
                                feeValue: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimables[i][0] || 0, item.bribeList[0].decimal).toString(),
                                feeUsd: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimables[i][0] || 0, item.bribeList[0].decimal).toString() * ((ref = item.bribeList[0]) === null || ref === void 0 ? void 0 : ref.usdPrice),
                                bribeList: item.bribeList.slice(1).map(function(element, j) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, element), {
                                        coinBalance: (0,formatBalance/* formatBigNumberToFixed */.U1)(claimables[i][j + 1] || 0, element.decimal).toString()
                                    });
                                }).filter(function(v) {
                                    return v.coinBalance > 0;
                                })
                            });
                        }).filter(function(v) {
                            return Number(v.feeValue) + Number(v.tokenListValue) > 0;
                        });
                        // console.log(dataFormat, 'dataFormat')
                        setTableData(dataFormat);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error, "error");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetch() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!account || !voterContract) return;
        fetch();
        timerRef1.current = setInterval(function() {
            fetch();
        }, 10000);
        // eslint-disable-next-line consistent-return
        return function() {
            clearInterval(timerRef1.current);
        };
    }, [
        account,
        voterContract
    ]);
    // 领取esnoah type - 1：领取esnoah 2：领取noah 3-领取全部 4-领取单个池子
    var handleReceiveEsNoah = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, item) {
            var method, args, estimate, promise1, promise2, promise11, promise21;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (type === 1) {
                            estimate = rewardsDistributorContract.estimateGas.claim;
                            method = rewardsDistributorContract.claim;
                            args = [
                                account
                            ];
                            // 领取质押奖励
                            setPendingText("".concat(t("noah416"), " ").concat(allData.collectedEsNoah, " esNOAH"));
                        } else if (type === 2) {
                            estimate = vesterContract.estimateGas.claim;
                            method = vesterContract.claim;
                            args = [];
                            // 领取已解锁
                            setPendingText("".concat(t("noah417"), " ").concat(allData.lockedNoah, " NOAH"));
                        } else if (type === 3) {
                            promise1 = new Promise(function(resolve) {
                                estimate = voterContract.estimateGas.reset;
                                method = voterContract.reset;
                                args = [];
                                if (reset) {
                                    setPendingText(t("noah418"));
                                    handleMultiple(estimate, method, args);
                                }
                            });
                            promise2 = new Promise(function(resolve) {
                                estimate = voterContract.estimateGas.claimBribes;
                                method = voterContract.claimBribes;
                                // console.log(tableData, 'tableData')
                                var args1 = tableData.filter(function(v) {
                                    return Number(v.feeValue) + Number(v.tokenListValue) > 0;
                                }).map(function(vv) {
                                    return vv.bribe;
                                });
                                // 列表是否有奖励
                                var isValue = tableData.reduce(function(total, currentValue) {
                                    return total + Number(currentValue.feeValue) + Number(currentValue.tokenListValue);
                                }, 0);
                                // console.log(isValue, 'isValue')
                                var args2 = isValue ? tableData.map(function(v) {
                                    if (Number(v.feeValue) > 0 && Number(v.tokenListValue) === 0) {
                                        return [
                                            v.pair_id
                                        ];
                                    }
                                    if (Number(v.feeValue) === 0 && Number(v.tokenListValue) > 0) {
                                        return (0,_to_consumable_array/* default */.Z)(v.bribeList.map(function(vv) {
                                            return vv.contract;
                                        }));
                                    }
                                    if (Number(v.feeValue) > 0 && Number(v.tokenListValue) > 0) {
                                        return [
                                            v.pair_id
                                        ].concat((0,_to_consumable_array/* default */.Z)(v.bribeList.map(function(vv) {
                                            return vv.contract;
                                        })));
                                    }
                                }) : [];
                                // console.log(args1, 'args1')
                                // console.log(args2, 'args2')
                                args = [
                                    args1,
                                    args2
                                ];
                                // 领取投票奖励
                                setPendingText(t("noah418"));
                                handleMultiple(estimate, method, args);
                            });
                            return [
                                2
                            ];
                        } else {
                            promise11 = new Promise(function(resolve) {
                                estimate = voterContract.estimateGas.reset;
                                method = voterContract.reset;
                                args = [];
                                if (reset) {
                                    setPendingText(t("noah418"));
                                    handleMultiple(estimate, method, args);
                                }
                            });
                            promise21 = new Promise(function(resolve) {
                                var BribeOtherContract = new contracts_lib_esm.Contract(item === null || item === void 0 ? void 0 : item.bribe, Bribe, signer);
                                console.log(BribeOtherContract, "BribeOtherContract");
                                // console.log(item, 'item')
                                estimate = BribeOtherContract.estimateGas.getReward;
                                method = BribeOtherContract.getReward;
                                // 列表是否有奖励
                                var args1 = [];
                                if (Number(item.feeValue) > 0 && Number(item.tokenListValue) === 0) {
                                    args1 = [
                                        item.pair_id
                                    ];
                                }
                                if (Number(item.feeValue) === 0 && Number(item.tokenListValue) > 0) {
                                    args1 = (0,_to_consumable_array/* default */.Z)(item.bribeList.map(function(vv) {
                                        return vv.contract;
                                    }));
                                }
                                // if (Number(item.feeValue) > 0 && Number(item.tokenListValue) > 0) {
                                args1 = [
                                    item.pair_id
                                ].concat((0,_to_consumable_array/* default */.Z)(item.bribeList.map(function(vv) {
                                    return vv.contract;
                                })));
                                // }
                                // console.log(args1, 'args1')
                                args = [
                                    account,
                                    args1
                                ];
                                // 领取投票奖励
                                setPendingText(t("noah418"));
                                handleMultiple(estimate, method, args);
                            });
                            return [
                                2
                            ];
                        }
                        onPresentResultModal();
                        // 领取成功/领取失败
                        setText({
                            successText: t("noah244"),
                            failText: t("noah245")
                        });
                        setRewardState({
                            attemptingTxn: true,
                            rewardErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    // console.log(response, 'responseresponse')
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    addTransaction(response, {
                                        summary: "reward NOAH",
                                        translatableSummary: {
                                            text: type === 1 ? "".concat(t("noah416"), " ").concat(allData.collectedEsNoah, " esNOAH") : type === 2 ? "".concat(t("noah417"), " ").concat(allData.lockedNoah, " NOAH") : t("noah418"),
                                            data: {}
                                        },
                                        type: "reward"
                                    });
                                });
                            }).catch(function(err) {
                                console.log(err, "err");
                                if (err && err.code !== 4001) {
                                    console.error("Reward failed", err);
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setRewardState({
                                    attemptingTxn: false,
                                    rewardErrorMessage: err && err.code !== 4001 ? t("Reward failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReceiveEsNoah(type, item) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMultiple = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(estimate, method, args) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        onPresentResultModal();
                        // 领取成功/领取失败
                        setText({
                            successText: t("noah244"),
                            failText: t("noah245")
                        });
                        setRewardState({
                            attemptingTxn: true,
                            rewardErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    // console.log(response, 'responseresponse')
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    addTransaction(response, {
                                        summary: "reward NOAH",
                                        translatableSummary: {
                                            text: t("noah418"),
                                            data: {}
                                        },
                                        type: "reward"
                                    });
                                });
                            }).catch(function(err) {
                                console.log(err, "err");
                                if (err && err.code !== 4001) {
                                    console.error("Reward failed", err);
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setRewardState({
                                    attemptingTxn: false,
                                    rewardErrorMessage: err && err.code !== 4001 ? t("Reward failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMultiple(estimate, method, args) {
            return _ref.apply(this, arguments);
        };
    }();
    // 增加减少解锁 0-增加 1-减少
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, debounceNumInput) {
            var method, args, estimate;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!type) {
                            estimate = vesterContract.estimateGas.deposit;
                            method = vesterContract.deposit;
                            args = [
                                (0,lib_esm.parseUnits)(debounceNumInput, 18).toString()
                            ];
                            setPendingText(t("Add %num% esNOAH to unlock", {
                                num: Number(allData.lockEsNoah) + Number(debounceNumInput)
                            }));
                        } else {
                            estimate = vesterContract.estimateGas.withdraw;
                            method = vesterContract.withdraw;
                            args = [
                                Math.floor(Number(debounceNumInput) / Number(allData.lockEsNoah) * 1000)
                            ];
                            setPendingText(t("Decrease %num% esNOAH to unlock", {
                                num: Number(debounceNumInput)
                            }));
                        }
                        // return
                        // 操作成功 / 操作失败
                        setText({
                            successText: t("noah389"),
                            failText: t("noah390")
                        });
                        onPresentResultModal();
                        setRewardState({
                            attemptingTxn: true,
                            rewardErrorMessage: undefined,
                            txHash: undefined
                        });
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    console.log(response, "responseresponse");
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    addTransaction(response, {
                                        summary: "locked NOAH",
                                        translatableSummary: {
                                            text: !type ? t("Add %num% esNOAH to unlock", {
                                                num: Number(allData.lockEsNoah) + Number(debounceNumInput)
                                            }) : t("Decrease %num% esNOAH to unlock", {
                                                num: Number(debounceNumInput)
                                            }),
                                            data: {}
                                        },
                                        type: "locked"
                                    });
                                });
                            }).catch(function(err) {
                                console.log(err, "err");
                                if (err && err.code !== 4001) {
                                    console.error("locked failed", err);
                                    setRewardState({
                                        attemptingTxn: false,
                                        rewardErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setRewardState({
                                    attemptingTxn: false,
                                    rewardErrorMessage: err && err.code !== 4001 ? t(" failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(type, debounceNumInput) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_LockModal, {
        allData: allData,
        handleSubmit: handleSubmit
    }), true, true, "LockModal"), 1), onPresentLockModal = ref12[0];
    // 每纪元奖励的总数量
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        var params = {
            pageSize: 1
        };
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, data, code, ref1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,service/* getWeeklyRewardDistrbutors */.sJ)(params, {
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, code = ref.code;
                            if (!code) {
                                ;
                                setServerData({
                                    price: (data === null || data === void 0 ? void 0 : data.price) || 0,
                                    weekReward: ((ref1 = data === null || data === void 0 ? void 0 : data.list[0]) === null || ref1 === void 0 ? void 0 : ref1.weekly_reward_distributor) || 0
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    }, []);
    // console.log('serverData', serverData)
    var getPeriodStart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var periodStart, totalSupplyAt, accountveNOAH, accountveNOAHValue, totalSupplyAtValue, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            MinterContract.periodStart() // 查询当前所在周期的开始时间
                        ];
                    case 1:
                        periodStart = _state.sent();
                        return [
                            4,
                            votingEscrowContract.totalSupplyAtT(Number(periodStart.toString()) + Number(604800))
                        ];
                    case 2:
                        totalSupplyAt = _state.sent();
                        return [
                            4,
                            votingEscrowContract.balanceOfAtT(account, Number(periodStart.toString()) + Number(604800))
                        ];
                    case 3:
                        accountveNOAH = _state.sent();
                        accountveNOAHValue = Number((0,formatBalance/* formatFixedNumber */.w$)(accountveNOAH || 0));
                        totalSupplyAtValue = Number((0,formatBalance/* formatFixedNumber */.w$)(totalSupplyAt || 0));
                        // console.log('最终计算结果', accountveNOAHValue / totalSupplyAtValue * serverData.weekReward)
                        // 本纪元预计获得
                        setEstiValue(accountveNOAHValue / totalSupplyAtValue * serverData.weekReward);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getPeriodStart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // if (serverData.weekReward && account && !MinterContract && !votingEscrowContract) return
        if (serverData.weekReward && account && MinterContract && votingEscrowContract) {
            getPeriodStart();
        }
    }, [
        serverData.weekReward,
        account,
        MinterContract,
        votingEscrowContract
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        footer: false,
        style: {
            paddingTop: !isMobile ? "0" : ""
        },
        isMobile: isMobile,
        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            isMobile: isMobile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "calc(50% - 10px)",
                                marginRight: "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    fontWeight: "600",
                                    mb: "5px",
                                    children: t("noah544")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    mb: "15px",
                                    children: t("noah545")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "calc(50% - 10px)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    fontWeight: "600",
                                    mb: "5px",
                                    children: t("noah309")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    mb: "15px",
                                    children: t("noah310")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCont, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HalfWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                mb: "18px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "#85868A",
                                                        small: true,
                                                        children: t("noah313")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        small: true,
                                                        children: [
                                                            (0,formatBalance/* getRes */.sR)(allData === null || allData === void 0 ? void 0 : allData.lockEsNoah, 4) || "0.0000",
                                                            " esNOAH"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "#85868A",
                                                            mr: "10px",
                                                            small: true,
                                                            children: t("noah438")
                                                        })
                                                    }),
                                                    Number(allData.lockEsNoah) === 0 ? // 未解锁
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        small: true,
                                                        children: t("noah317")
                                                    }) : Number(allData.lockEsNoah) > 0 && Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) === 0 ? // 停止解锁
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        small: true,
                                                        children: t("noah316")
                                                    }) : // 解锁中
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        small: true,
                                                        children: t("noah439")
                                                    })
                                                ]
                                            }),
                                            allData.lockedNoah > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiveCont, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        small: true,
                                                        children: [
                                                            t("noah318"),
                                                            " ",
                                                            (0,formatBalance/* getRes */.sR)(allData.lockedNoah, 4) || "0.0000",
                                                            " NOAH"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "#F0B000",
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        bold: true,
                                                        small: true,
                                                        onClick: function() {
                                                            if (!account) {
                                                                onPresentConnectModal();
                                                                return;
                                                            }
                                                            handleReceiveEsNoah(2);
                                                        },
                                                        children: t("noah237")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        children: isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfButton, {
                                            style: {
                                                background: "transparent",
                                                width: "100%"
                                            },
                                            onClick: function() {
                                                if (!account) {
                                                    onPresentConnectModal();
                                                    return;
                                                }
                                                onPresentLockModal();
                                            },
                                            children: t("noah321")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HalfWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        mb: "18px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                color: "#85868A",
                                                small: true,
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    t("noah542"),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                                        type: "info",
                                                        text: t("noah543"),
                                                        placement: "top-start",
                                                        ml: "0",
                                                        style: {
                                                            position: "relative",
                                                            top: "-1px"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                small: true,
                                                children: [
                                                    (0,formatBalance/* getRes */.sR)(estiValue, 4) || "0.0000",
                                                    " esNOAH"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        mb: "18px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                color: "#85868A",
                                                small: true,
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    t("noah589"),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                                        type: "info",
                                                        text: t("noah584"),
                                                        placement: "top-start",
                                                        ml: "0",
                                                        style: {
                                                            position: "relative",
                                                            top: "-1px"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                small: true,
                                                children: Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        Number((0,formatBalance/* truncateZero */.bW)(estiValue * 52 / Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) * 100, 2)) < 0.01 ? "< 0.01" : (0,formatBalance/* truncateZero */.bW)(estiValue * 52 / Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) * 100, 2),
                                                        "%"
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "0.00%"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        mb: "18px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "#85868A",
                                                small: true,
                                                children: t("noah311")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                small: true,
                                                children: [
                                                    (0,formatBalance/* getRes */.sR)(allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah, 4) || "0.0000",
                                                    " esNOAH"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        mt: allData.lockedNoah > 0 ? "100px" : "50px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfButton, {
                                            style: {
                                                borderColor: !Number(allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah) ? "#fff" : "#000",
                                                width: "100%"
                                            },
                                            disabled: !Number(allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah),
                                            onClick: function() {
                                                if (!account) {
                                                    onPresentConnectModal();
                                                    return;
                                                }
                                                handleReceiveEsNoah(1);
                                            },
                                            children: t("noah320")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "24px",
                                    fontWeight: "600",
                                    mb: "5px",
                                    children: t("noah322")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    mb: "15px",
                                    children: t("noah323")
                                })
                            ]
                        }),
                        account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                height: "40px",
                                fontSize: "14px"
                            },
                            disabled: tableData.every(function(v) {
                                return Number(v.feeValue) + Number(v.tokenListValue) === 0;
                            }),
                            onClick: function() {
                                handleReceiveEsNoah(3);
                            },
                            children: t("noah401")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCont, {
                    style: {
                        padding: "40px",
                        backgroundColor: "#fff",
                        borderRadius: "30px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHead, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "headText",
                                        children: t("noah286")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "headText",
                                        children: t("noah324")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "headText",
                                        children: t("noah325")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "headText",
                                        children: t("noah291")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCont, {
                                children: tableData.length > 0 ? tableData === null || tableData === void 0 ? void 0 : tableData.map(function(poolData, index) {
                                    var ref, ref1, ref2;
                                    var symbolChange = {
                                        token0: {
                                            name: poolData.name0,
                                            symbol: poolData.symbol0,
                                            address: poolData.contract0
                                        },
                                        token1: {
                                            name: poolData.name1,
                                            symbol: poolData.symbol1,
                                            address: poolData.contract1
                                        }
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        mb: "10px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                className: "bodyText",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                        token0: symbolChange.token0,
                                                        token1: symbolChange.token1,
                                                        size: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            marginLeft: "30px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                small: true,
                                                                children: symbolChange === null || symbolChange === void 0 ? void 0 : (ref = symbolChange.token0) === null || ref === void 0 ? void 0 : ref.symbol
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                small: true,
                                                                children: [
                                                                    "/",
                                                                    symbolChange === null || symbolChange === void 0 ? void 0 : (ref1 = symbolChange.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                className: "bodyText",
                                                alignItems: "center",
                                                children: (poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd) > 0.01 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    small: true,
                                                    children: [
                                                        "$ ",
                                                        (0,formatBalance/* truncateZero */.bW)(poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd, 2)
                                                    ]
                                                }) : (poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd) == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    small: true,
                                                    children: "$ 0.00"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    small: true,
                                                    children: "$ < 0.01"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                className: "bodyText",
                                                alignContent: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                children: (poolData === null || poolData === void 0 ? void 0 : poolData.bribeList.length) > 0 ? poolData === null || poolData === void 0 ? void 0 : (ref2 = poolData.bribeList) === null || ref2 === void 0 ? void 0 : ref2.map(function(v, i) {
                                                    return v.type === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        small: true,
                                                        children: [
                                                            (0,formatBalance/* getRes */.sR)(v === null || v === void 0 ? void 0 : v.coinBalance, 4),
                                                            " ",
                                                            v.symbol
                                                        ]
                                                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    small: true,
                                                    children: "0"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                className: "bodyText",
                                                alignItems: "center",
                                                onClick: function() {
                                                    handleReceiveEsNoah(4, poolData);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontSize: "16px",
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: t("noah237")
                                                })
                                            })
                                        ]
                                    }, index);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "nodata",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/claim/nodata.png",
                                            alt: "",
                                            style: {
                                                width: "70px",
                                                height: "50px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "18px",
                                            color: "#85868A",
                                            mb: "20px",
                                            mt: "12px",
                                            children: t("noah338")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/vote",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("noah339"),
                                                    " >"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            isMobile: isMobile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "15px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    mb: "5px",
                                    children: t("noah544")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    small: true,
                                    children: t("noah545")
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCont, {
                    style: {
                        padding: "30px 20px",
                        backgroundColor: "#fff",
                        borderRadius: "30px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "box-cls",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mb: "15px",
                                mt: "0px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#85868A",
                                        small: true,
                                        children: t("noah313")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        small: true,
                                        children: [
                                            (0,formatBalance/* getRes */.sR)((allData === null || allData === void 0 ? void 0 : allData.lockEsNoah) || "0.0000", 4) || "0.0000",
                                            " esNOAH"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#85868A",
                                            mr: "10px",
                                            small: true,
                                            children: t("noah438")
                                        })
                                    }),
                                    Number(allData.lockEsNoah) === 0 ? // 未解锁
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        small: true,
                                        children: t("noah317")
                                    }) : Number(allData.lockEsNoah) > 0 && Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) === 0 ? // 停止解锁
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        small: true,
                                        children: t("noah316")
                                    }) : // 解锁中
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        small: true,
                                        children: t("noah439")
                                    })
                                ]
                            }),
                            allData.lockedNoah > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceiveCont, {
                                style: {
                                    marginBottom: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "13px",
                                        children: [
                                            t("noah318"),
                                            " ",
                                            (0,formatBalance/* getRes */.sR)(allData === null || allData === void 0 ? void 0 : allData.lockedNoah, 4) || "0.0000",
                                            " NOAH"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#F0B000",
                                        fontSize: "13px",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            if (!account) {
                                                onPresentConnectModal();
                                                return;
                                            }
                                            handleReceiveEsNoah(2);
                                        },
                                        children: t("noah237")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            isWrongNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfButton, {
                                style: {
                                    background: "transparent",
                                    fontSize: "14px",
                                    height: "42px",
                                    width: "100%",
                                    marginTop: "24px"
                                },
                                onClick: function() {
                                    if (!account) {
                                        onPresentConnectModal();
                                        return;
                                    }
                                    onPresentLockModal();
                                },
                                children: t("noah321")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "15px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    mb: "5px",
                                    children: t("noah309")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    small: true,
                                    children: t("noah310")
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCont, {
                    style: {
                        padding: "30px 20px",
                        backgroundColor: "#fff",
                        borderRadius: "30px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "box-cls",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mb: "15px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#85868A",
                                        small: true,
                                        children: t("noah542")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        small: true,
                                        children: [
                                            (0,formatBalance/* getRes */.sR)(estiValue, 4) || "0.0000",
                                            " esNOAH"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mb: "18px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#85868A",
                                        small: true,
                                        children: t("noah589")
                                    }),
                                    Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            Number((0,formatBalance/* truncateZero */.bW)(estiValue * 52 / Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) * 100, 2)) < 0.01 ? "< 0.01" : (0,formatBalance/* truncateZero */.bW)(estiValue * 52 / Number(allData === null || allData === void 0 ? void 0 : allData.lockedData) * 100, 2),
                                            "%"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "0.00%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mb: "15px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#85868A",
                                        small: true,
                                        children: t("noah311")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        small: true,
                                        children: [
                                            (0,formatBalance/* getRes */.sR)((allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah) || "0.0000", 4) || "0.0000",
                                            " esNOAH"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfButton, {
                                    disabled: !Number(allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah),
                                    style: {
                                        fontSize: "14px",
                                        height: "42px",
                                        borderColor: !Number(allData === null || allData === void 0 ? void 0 : allData.collectedEsNoah) ? "#fff" : "#000",
                                        width: "100%"
                                    },
                                    onClick: function() {
                                        if (!account) {
                                            onPresentConnectModal();
                                            return;
                                        }
                                        handleReceiveEsNoah(1);
                                    },
                                    children: t("noah320")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    mb: "15px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                width: "65%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "18px",
                                    fontWeight: "500",
                                    mb: "5px",
                                    children: t("noah322")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    children: t("noah323")
                                })
                            ]
                        }),
                        account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                height: "40px",
                                fontSize: "14px"
                            },
                            disabled: tableData.every(function(v) {
                                return Number(v.feeValue) + Number(v.tokenListValue) === 0;
                            }),
                            onClick: function() {
                                handleReceiveEsNoah(3);
                            },
                            children: t("noah401")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCont, {
                    style: {
                        padding: "30px 20px",
                        backgroundColor: "#fff",
                        borderRadius: "30px"
                    },
                    children: tableData.length > 0 ? tableData === null || tableData === void 0 ? void 0 : tableData.map(function(poolData, index) {
                        var ref, ref1, ref2;
                        var symbolChange = {
                            token0: {
                                name: poolData.name0,
                                symbol: poolData.symbol0,
                                address: poolData.contract0
                            },
                            token1: {
                                name: poolData.name1,
                                symbol: poolData.symbol1,
                                address: poolData.contract1
                            }
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                borderBottom: index === tableData.length - 1 ? "0px solid #DBDBDB" : "1px solid #eee",
                                marginBottom: index === tableData.length - 1 ? "0px" : "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                            token0: symbolChange.token0,
                                            token1: symbolChange.token1,
                                            size: 30
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                marginLeft: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    children: symbolChange === null || symbolChange === void 0 ? void 0 : (ref = symbolChange.token0) === null || ref === void 0 ? void 0 : ref.symbol
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "/",
                                                        symbolChange === null || symbolChange === void 0 ? void 0 : (ref1 = symbolChange.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    mb: "15px",
                                    mt: "15px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#85868A",
                                            small: true,
                                            children: t("noah324")
                                        }),
                                        (poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd) > 0.01 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            small: true,
                                            children: [
                                                "$ ",
                                                (0,formatBalance/* truncateZero */.bW)(poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd, 2)
                                            ]
                                        }) : (poolData === null || poolData === void 0 ? void 0 : poolData.feeUsd) == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            small: true,
                                            children: "$ 0.00"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            small: true,
                                            children: "$ < 0.01"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    mb: "15px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#85868A",
                                            small: true,
                                            children: t("noah325")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            children: (poolData === null || poolData === void 0 ? void 0 : poolData.bribeList.length) > 0 ? poolData === null || poolData === void 0 ? void 0 : (ref2 = poolData.bribeList) === null || ref2 === void 0 ? void 0 : ref2.map(function(v, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    small: true,
                                                    children: [
                                                        (0,formatBalance/* getRes */.sR)(v === null || v === void 0 ? void 0 : v.coinBalance, 4),
                                                        " ",
                                                        v.symbol
                                                    ]
                                                }, i);
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                small: true,
                                                children: "0"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        width: "100%",
                                        height: "36px",
                                        fontSize: "14px",
                                        backgroundColor: "transparent",
                                        borderColor: "#c1c2c4"
                                    },
                                    onClick: function() {
                                        handleReceiveEsNoah(4, poolData);
                                    },
                                    children: t("noah237")
                                })
                            ]
                        }, index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        className: "nodata",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/claim/nodata.png",
                                alt: "",
                                style: {
                                    width: "50px",
                                    height: "50px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "#85868A",
                                mb: "20px",
                                mt: "12px",
                                children: t("noah338")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/vote",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        t("noah339"),
                                        " >"
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/reward/index.tsx


var RewardPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reward, {});
};
RewardPage.Layout = RewardPage;
// RewardPage.mp = false
/* harmony default export */ var reward = (RewardPage);


/***/ }),

/***/ 65044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ getAdd; },
/* harmony export */   "FH": function() { return /* binding */ toFixed; },
/* harmony export */   "Pn": function() { return /* binding */ getFullNum; },
/* harmony export */   "U1": function() { return /* binding */ formatBigNumberToFixed; },
/* harmony export */   "az": function() { return /* binding */ formatBalance; },
/* harmony export */   "b9": function() { return /* binding */ truncateHasZero; },
/* harmony export */   "bW": function() { return /* binding */ truncateZero; },
/* harmony export */   "bd": function() { return /* binding */ formatEffectiveNumber; },
/* harmony export */   "cy": function() { return /* binding */ getSub; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "m8": function() { return /* binding */ formatEffectiveNumberSix; },
/* harmony export */   "sR": function() { return /* binding */ getRes; },
/* harmony export */   "w$": function() { return /* binding */ formatFixedNumber; }
/* harmony export */ });
/* unused harmony exports getDecimalAmount, getBalanceAmount, getBalanceNumber, getFullDisplayBalance, formatNumber, formatBigNumber, formatLocalisedCompactNumber, formatLpBalance, truncate, formatEffectiveNumber2 */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61744);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65208);
/* harmony import */ var _getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44356);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74152);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33730);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable */ 






 // 中文繁体
 // 韩文
// 加法函数
function getAdd(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.plus(num2).toString();
}
// 减法函数
function getSub(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.minus(num2).toString();
}
function getTime(value) {
    return moment__WEBPACK_IMPORTED_MODULE_3___default()(value).format("YYYY-MM-DD HH:mm:ss");
//   const zone = moment().utcOffset() / 60; // 时区
//   const formattedTime = moment(value).add(0 + zone, 'hours');
//   const codeFromStorage = getLanguageCodeFromLS() // current language code
//   // console.log('当前缓存的语言', codeFromStorage)
//   if (codeFromStorage === 'zh-TW') {
//     formattedTime.locale('zh-tw');
//     // return formattedTime.format("MMMDo, A hh:mm, dddd");
//     return formattedTime.format("YYYY年MMMD Ah:mm");
//   } else if (codeFromStorage === 'ko-KR') {
//     formattedTime.locale('ko');
//     // return formattedTime.format("hh:mm A, dddd, MMM D");
//     return formattedTime.format("hh:mm A, YYYY MMM D");
//   } else {
//     formattedTime.locale('en');
//     // return formattedTime.format("hh:mm A, ddd, MMM D");
//     return formattedTime.format("MMM D, YYYY, h:mm A");
//   }
//   // return moment(time).add(0 + zone, 'hours').format("hh:mm A, dddd, MMM. D")
// // },
// // return moment(value).format('MMM D, YYYY, h:mm A')
}
function formatBalance(price, precision) {
    var realPrice = formatBigNumber(price);
    var scaledPrice = Number(realPrice) * Math.pow(10, 18);
    var formattedPrice = (scaledPrice / Math.pow(10, precision)).toFixed(precision);
    return formattedPrice;
}
/**
 * Take a formatted amount, e.g. 15 EOS and convert it to full decimal value, e.g. 15000000000000000
 */ var getDecimalAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).times(getFullDecimalMultiplier(decimals));
};
var getBalanceAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).dividedBy(getFullDecimalMultiplier(decimals));
};
/**
 * This function is not really necessary but is used throughout the site.
 */ var getBalanceNumber = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return getBalanceAmount(balance, decimals).toNumber();
};
var getFullDisplayBalance = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, displayDecimals = arguments.length > 2 ? arguments[2] : void 0;
    return getBalanceAmount(balance, decimals).toFixed(displayDecimals);
};
/**
 * Don't use the result to convert back to number.
 * It uses undefined locale which uses host language as a result.
 * Languages have different decimal separators which results in inconsistency when converting back this result to number.
 */ var formatNumber = function(number) {
    var minPrecision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, maxPrecision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var options = {
        minimumFractionDigits: minPrecision,
        maximumFractionDigits: maxPrecision
    };
    return number.toLocaleString(undefined, options);
};
/**
 * Method to format the display of wei given an EthersBigNumber object
 * Note: does NOT round
 */ var formatBigNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var remainder = number.mod(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(10).pow(decimals - displayDecimals));
    return (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number.sub(remainder), decimals);
};
/**
 * Method to format the display of wei given an EthersBigNumber object with toFixed
 * Note: rounds
 */ var formatBigNumberToFixed = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var formattedString = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number, decimals);
    return (+formattedString).toFixed(displayDecimals);
};
/**
 * Formats a FixedNumber like BigNumber
 * i.e. Formats 9763410526137450427.1196 into 9.763 (3 display decimals)
 */ var formatFixedNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    // Remove decimal
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(number.toString().split("."), 1), leftSide = ref[0];
    return formatBigNumber(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(leftSide), displayDecimals, decimals);
};
var formatLocalisedCompactNumber = function(number) {
    var codeFromStorage = getLanguageCodeFromLS();
    var isClient = "object" === "object";
    var isSupported = window === null || window === void 0 ? void 0 : window.Intl;
    // For clients do not support Intl, just return number
    if (isClient && !isSupported) {
        return "".concat(number);
    }
    return new Intl.NumberFormat(codeFromStorage, {
        notation: "compact",
        compactDisplay: "long",
        maximumSignificantDigits: 2
    }).format(number);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (formatLocalisedCompactNumber)));
var formatLpBalance = function(balance) {
    var stakedBalanceBigNumber = getBalanceAmount(balance);
    if (stakedBalanceBigNumber.gt(0) && stakedBalanceBigNumber.lt(0.00001)) {
        return "< 0.00001";
    }
    return stakedBalanceBigNumber.toFixed(5, BigNumber.ROUND_DOWN);
};
// 截取，只保留有效位数
var truncate = function(num, decimals) {
    var multiplier = Math.pow(10, decimals);
    return Math.floor(num * multiplier) / multiplier;
};
// 截取，包含0
var truncateZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1, index + 1 + decimals);
        return mainPart + "." + decimalPart.padEnd(decimals, "0");
    } else {
        return str + "." + "0".repeat(decimals);
    }
};
// 截取有效位数，从小数部分非零数字开始计数
var truncateHasZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1);
        var nonZeroIndex = 0;
        while(nonZeroIndex < decimalPart.length && decimalPart[nonZeroIndex] === "0"){
            nonZeroIndex++;
        }
        var truncatedDecimalPart = decimalPart.slice(0, nonZeroIndex + decimals);
        return mainPart + "." + truncatedDecimalPart;
    } else {
        return str;
    }
};
// 返回3位或指定有效位小数，例如：200.000输出200，200.000123输出200.000123
var formatEffectiveNumber = function(num) {
    var n = Number(num);
    var str = n.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1 && str.length > decimalIndex + 4) {
        return str.slice(0, decimalIndex + 4);
    } else {
        return str;
    }
};
var formatEffectiveNumberSix = function(decimal) {
    var decimalString = decimal.toString();
    var match = decimalString.match(/^0\.0*([1-9]\d{0,5})/);
    if (match) {
        return match[0];
    } else {
        return Number(decimal).toPrecision(8);
    }
};
var formatEffectiveNumber2 = function(num, decimal) {
    var str = num.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1) {
        var decimals = str.slice(decimalIndex + 1);
        var nonZeroIndex = decimals.search(/[^0]/) //查找第一个非零小数的位置
        ;
        if (nonZeroIndex !== -1) {
            //保留指定有效位数的小数
            var effectiveDecimals = decimals.slice(nonZeroIndex, nonZeroIndex + decimal);
            return str.slice(0, decimalIndex + 1) + effectiveDecimals;
        }
    }
    return str;
};
// 取消四舍五入
var getRes = function(num) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    // if (Number(num) === Math.floor(num)) return Math.floor(num);
    var res = [];
    var addNum = 0;
    // eslint-disable-next-line no-param-reassign
    num += "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(num.split("."), 2), zs = ref[0], xs = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/^(-?)(\d+\.\d+|\d+)$/.exec(zs), 3), symbol = ref1[1], zsNum = ref1[2];
    if (!xs) return num;
    for(var i = 0; i < xs.length; i++){
        var ele = xs[i];
        // eslint-disable-next-line
        if (ele != 0) {
            // if (xs[i + digit] && xs[i + digit] > 4) {
            //   addNum = 1
            //   for (let j = i + (digit - 1); j >= 0; j--) {
            //     if (Number(xs[j]) + addNum === 10) res[j] = '0'
            //     else {
            //       res[j] = Number(xs[j]) + addNum
            //       addNum = 0
            //     }
            //   }
            // } else {
            for(var k = i; k <= i + (digit - 1); k++){
                res[k] = xs[k];
            }
            break;
        } else res[i] = xs[i];
    }
    return getFullNum(Number("".concat(symbol + (Number(zsNum) + addNum), ".").concat(res.join(""))));
};
var getFullNum = function(num) {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return num;
    }
    // 处理不需要转换的数字
    var str = String(num);
    if (!/e/i.test(str)) {
        return num;
    }
    return Number(num).toFixed(18).replace(/\.?0+$/, "");
};
var toFixed = function(value, precision) {
    var numberValue = Number(value);
    return numberValue.toFixed(precision);
};


/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CurrencyLogo; },
  "g": function() { return /* binding */ DoubleCurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/LogoLoader.tsx





var BAD_SRCS = [];
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */ var LogoLoader = function(_param) {
    var src = _param.src, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var srcFailedLoading = BAD_SRCS.includes(src);
    if (src && !srcFailedLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS.push(src);
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ var CurrencyLogo_LogoLoader = (LogoLoader);

;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */\n  background-color: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(CurrencyLogo_LogoLoader).withConfig({
    componentId: "sc-1182136a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg && "-6px";
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg ? "4" : "3";
});
var CurrencyLogo = function(_param) {
    var address = _param.address, symbol = _param.symbol, _size = _param.size, size = _size === void 0 ? "24px" : _size, _firstimg = _param.firstimg, firstimg = _firstimg === void 0 ? "false" : _firstimg, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "address",
        "symbol",
        "size",
        "firstimg"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var src = (0,react.useMemo)(function() {
        // const checksummedAddress = isAddress(address)
        if (address && symbol) {
            // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
            // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
            return "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(address.toLowerCase(), "-").concat(symbol.toLowerCase(), ".png");
        }
        return null;
    }, [
        address,
        symbol,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, (0,_object_spread/* default */.Z)({
        size: size,
        src: src,
        alt: "token logo",
        firstimg: firstimg
    }, rest));
};
var DoubleCurrencyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1182136a-1"
})(_templateObject1());
var DoubleCurrencyLogo = function(param) {
    var token0 = param.token0, token1 = param.token1, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleCurrencyWrapper, {
        children: [
            (token0 === null || token0 === void 0 ? void 0 : token0.address) && (token0 === null || token0 === void 0 ? void 0 : token0.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token0 === null || token0 === void 0 ? void 0 : token0.address,
                symbol: token0 === null || token0 === void 0 ? void 0 : token0.symbol,
                size: "".concat(size.toString(), "px"),
                firstimg: "true"
            }),
            (token1 === null || token1 === void 0 ? void 0 : token1.address) && (token1 === null || token1 === void 0 ? void 0 : token1.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token1 === null || token1 === void 0 ? void 0 : token1.address,
                symbol: token1 === null || token1 === void 0 ? void 0 : token1.symbol,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};


/***/ }),

/***/ 33109:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"_voter","type":"address"},{"internalType":"bool","name":"_isForPair","type":"bool"},{"internalType":"address[]","name":"_allowedRewardTokens","type":"address[]"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":false,"internalType":"address[]","name":"tokens","type":"address[]"},{"indexed":false,"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"name":"ClaimFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"reward","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"ClaimRewards","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"reward","type":"address"},{"indexed":false,"internalType":"uint256","name":"epoch","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"fee","type":"uint256"}],"name":"NotifyReward","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Voter","type":"event"},{"inputs":[],"name":"_ve","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"account","type":"address"}],"name":"_voted","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"tokens","type":"address[]"}],"name":"_withdrawBribe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"batchEarned","outputs":[{"internalType":"address[]","name":"tokens","type":"address[]"},{"internalType":"uint256[]","name":"claimables","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"bribeStart","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"checkpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimFees","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"account","type":"address"}],"name":"earned","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"_nCheckPoints","type":"uint256"}],"name":"getCheckpoint","outputs":[{"components":[{"internalType":"uint256","name":"timestamp","type":"uint256"},{"internalType":"uint256","name":"balanceOf","type":"uint256"}],"internalType":"struct Bribe.Checkpoint","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorBalanceIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"getPriorSupplyIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"address[]","name":"tokens","type":"address[]"}],"name":"getReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_nCheckPoints","type":"uint256"}],"name":"getSupplyCheckpoint","outputs":[{"components":[{"internalType":"uint256","name":"timestamp","type":"uint256"},{"internalType":"uint256","name":"supply","type":"uint256"}],"internalType":"struct Bribe.SupplyCheckpoint","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isForPair","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"isReward","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"lastEarn","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"lastTimeRewardApplicable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lastWithdrawEpoch","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"left","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"notifyRewardAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"numCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"periodFinish","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"rewards","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"rewardsListLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"supplyCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"supplyNumCheckpoints","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"address","name":"oldToken","type":"address"},{"internalType":"address","name":"newToken","type":"address"}],"name":"swapOutRewardToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenRewardsPerEpoch","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"voter","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2632,9774,2888,179], function() { return __webpack_exec__(77085); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);